import { render } from "./TNovoUsuario.vue?vue&type=template&id=c79d078c"
const script = {}

import "./TNovoUsuario.vue?vue&type=style&index=0&id=c79d078c&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__